import { Callout, Card, Intent, NumericInput } from '@blueprintjs/core';
import { PriceRange, SearchStatistics } from '@retro-ui/api-contract';
import _ from 'lodash';

import cls from './Filter.module.css';

interface PriceFilterCardProps {
  priceStatistics: SearchStatistics['price'];
  value?: PriceRange;
  onChange: (value?: PriceRange) => void;
}

export function PriceFilterCard(props: PriceFilterCardProps) {
  const { priceStatistics, value, onChange } = props;

  const statisticsMin = (priceStatistics.min && Math.floor(priceStatistics.min * 100) / 100) ?? undefined;
  const statisticsMax = (priceStatistics.max && Math.ceil(priceStatistics.max * 100) / 100) ?? undefined;

  const valuesError = value && _.isNumber(value[0]) && _.isNumber(value[1]) && value[0] > value[1];

  return (
    <Card>
      <small className={cls.label}>SM PRICE</small>
      <div className={cls.filterPrice}>
        <NumericInput
          placeholder={statisticsMin !== undefined ? String(statisticsMin) : ''}
          value={value?.[0] !== undefined ? String(value?.[0]) : ''}
          onValueChange={(valueAsNumber, valueAsString) => {
            onChange([valueAsString.length > 0 ? valueAsNumber : undefined, value?.[1]]);
          }}
          stepSize={10}
          leftIcon="dollar"
          intent={valuesError ? 'danger' : 'none'}
          fill
          min={statisticsMin}
          max={statisticsMax}
        />
        —
        <NumericInput
          placeholder={statisticsMax !== undefined ? String(statisticsMax) : ''}
          value={value?.[1] !== undefined ? String(value?.[1]) : ''}
          onValueChange={(valueAsNumber, valueAsString) => {
            onChange([value?.[0], valueAsString.length > 0 ? valueAsNumber : undefined]);
          }}
          stepSize={10}
          leftIcon="dollar"
          intent={valuesError ? 'danger' : 'none'}
          fill
          min={statisticsMin}
          max={statisticsMax}
        />
      </div>
      {valuesError && <Callout intent={Intent.DANGER}>Min price should be less than max price.</Callout>}
    </Card>
  );
}
